// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-components-fetch-error-styles__wrap--IL8vM"};